import React, { useEffect } from 'react';
import AOS from 'aos'
import 'aos/dist/aos.css'

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 2500 });
  }, []);
  return (
    <div className='w-full h-full bg-[#0a192f] flex justify-center items-center p-4'>
      <div name='contact' className='mt-[10rem] md:mt-[14rem]'>
        <form data-aos='fade' method='POST' action="https://getform.io/f/6bf6fb60-c76f-46a1-b756-2214529f9709" className='flex flex-col max-w-[600px] w-full mb-[2rem] md:mt-[6rem]'>
          <div className='pb-8'>
            <p className='text-4xl font-bold inline border-b-4 border-pink-600 text-gray-300'>Contact</p>
            <p className='text-gray-300 py-4'>Submit the form below or shoot me an email - ryansamudra67@gmail.com</p>
          </div>
          <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
          <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
          <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
          <button className='text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</button>
        </form>
      </div>
    </div>
  )
}

export default Contact